<!-- <template>
  <div id="vmain" class="event-container sys-container">
    <el-container>
      <el-header v-bind:style="{'display': headerDisplay}" style="height:14rem; ">
        <vHeader :pageInfo=pageInfo @toggle="toggle" @getDefaultMenu="getDefaultMenu" />
      </el-header>
      <el-container class="event-container sys-container" style=" padding: 0.1em 0;">        
        <el-main style="background:white; padding: 0; min-height: 20em;">
                <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect"
                    v-if="pageInfo!=null"
                    background-color="#00bfff"
                    text-color="#fff"
                    active-text-color="#EEDEB0">
                    <el-menu-item
                        v-for="(it,index) in pageInfo[0].subMenu" :key="index" :index="'1-'+index" :name="'M1'+index"
                        @click="toggle(0, index)">
                        <img src="@/assets/images/arrow_cg.gif" style="color:#f2ce2b;"/>&nbsp;{{it.title}}
                    </el-menu-item>
                
                </el-menu>
 
                <vTitle :pageInfo=pageInfo />
                <component class="container well" style="background: transparent; padding: 0.5rem 0.65rem;" v-bind:is="currentComponent" @getDefaultMenu="getDefaultMenu" ></component>
          </el-main>
      </el-container>
              <el-footer style="text-align: right; font-size: 12px; background: transparent;">
                <vFooter :pageInfo=pageInfo />        </el-footer>

    </el-container>
  </div>
</template> -->

<template>
  <div id="vmain" class="event-container sys-container">
    <!-- 整體容器 -->
    <el-container>
      <!-- 頁面頭部 -->
      <el-header :style="{'display': headerDisplay}" style="height: 14rem;">
        <vHeader 
          :pageInfo="pageInfo" 
          @toggle="toggle" 
          @getDefaultMenu="getDefaultMenu" 
        />
      </el-header>

      <!-- 主體容器 -->
      <el-container class="event-container sys-container">
        <!-- 主體內容 -->
        <el-main style="background: white; padding: 0; min-height: 20em;">
          <!-- 水平導航菜單 -->
          <el-menu 
            v-if="pageInfo != null" 
            :default-active="activeIndex" 
            class="el-menu-demo" 
            mode="horizontal" 
            background-color="#00bfff"
            text-color="#fff"
            active-text-color="#EEDEB0"
            @select="handleSelect"
          >
            <el-menu-item
              v-for="(item, index) in pageInfo[0].subMenu"
              :key="index"
              :index="'1-' + index"
              :name="'M1' + index"
              @click="toggle(0, index)"
            >
              <img 
                src="@/assets/images/arrow_cg.gif" 
                alt="Menu Icon" 
                style="color: #f2ce2b;"
              />
              &nbsp;{{ item.title }}
            </el-menu-item>
          </el-menu>

          <!-- 標題區塊 -->
          <vTitle :pageInfo="pageInfo" />

          <!-- 動態內容區 -->
          <component 
            class="container well" 
            style="background: transparent; padding: 0.5rem 0.65rem;" 
            :is="currentComponent" 
            @getDefaultMenu="getDefaultMenu" 
          ></component>
        </el-main>
      </el-container>

      <!-- 頁面底部 -->
      <el-footer style="text-align: right; font-size: 12px; background: transparent;">
        <vFooter :pageInfo="pageInfo" />
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import Vue from 'vue'
import vHeader from '@/components/common/HeaderView.vue'
import vTitle from '@/components/common/TitlePage.vue'
import vFooter from '@/components/common/FooterView.vue'
export default {
  name: 'vmain',
  props: ['init'],
  components: {
    vHeader,
    vTitle,
    vFooter
  },
  data () {
    return {
      pageInfo: null,
      currentComponent: '',
      jsData: [],
      isIE: false
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    user () {
      return this.$store.getters.getUser
    },
    headerDisplay () {
      return (this.isIE? 'ruby': 'contents');
    },
    menuId () {
      return (this.$store.getters.getPageId>=0? "1-".concat(this.$store.getters.getPageId): '')
    },
    setting () {
      return this.$store.getters.getSetting
    },
    headerColor () {
      let url = '';
      if (this.setting!=null && this.setting.bgColor != null && this.setting.bgColor[0]!= null && this.setting.bgColor[0].codeName.length>0) {
        url = this.setting.bgColor[0].codeName;
      }
      return url
    },
  },
  methods: {
    handleClick(tab, event) {
      this.toggle(0, tab.index);
    },
    toggle: function (appId, pageId) {
      if (appId==-2 && pageId==-2) {
        this.$store.dispatch('actionAppId', -2);
        this.$store.dispatch('actionPageId', -2);
        this.setCurComp('Help');
      } else if (appId==-3 && pageId==-3) {
        this.$store.dispatch('actionAppId', -3);
        this.$store.dispatch('actionPageId', -3);
        this.setCurComp('Login');
      } else if (appId==-4 && pageId==-4) {
        this.$store.dispatch('actionAppId', -4);
        this.$store.dispatch('actionPageId', -4);
        this.setCurComp('Warning');
      } else {          
        this.$store.dispatch('actionAppId', appId);
        this.$store.dispatch('actionPageId', pageId);
        if ((null != this.pageInfo) && (appId < this.pageInfo.length)) {
          this.setCurComp(this.pageInfo[appId].subMenu[pageId].path);
        }
      }
      this.setPageTitle();
    },
    setPageTitle: function() {
      let url = ''
      if ((this.pageInfo != null) && 
          (appId < this.pageInfo.length) &&
          (this.$store.getters.getAppId > -1) && 
          (this.$store.getters.getPageId > -1)) {
        var appId = this.$store.getters.getAppId
        var pageId = this.$store.getters.getPageId 
        url = this.pageInfo[appId].subMenu[pageId].title
      }
      //console.log('======url===== :' + url)
      this.$store.dispatch('setSysTitle', url)
    },
    setCurComp: function (evtValue) {
      // this.currentComponent = evtValue
      if (evtValue !== null) {
        this.currentComponent = evtValue
      } else {
        this.currentComponent = 'Help'
      }
    },
    capitalizeFirstLetter: function (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    setComponent: function () {
      let cFlag = false;
      let appId = 0, pageId = 0, sort = -1;
      if ((null != this.pageInfo) && 
          (0 < this.pageInfo.length) &&
          (this.pageInfo[0].subMenu != null)) {
        var len = this.pageInfo[0].subMenu.length
        var vm = this
        const requireComponent = require.context('.', false, /\.vue$/)
        requireComponent.keys().forEach(fileName => {
          const componentConfig = requireComponent(fileName)
          // ?�為得到?�filename?��??? './baseButton.vue', ?�以這裡?�們去?�頭?�尾，只保�??�正?��?案�?
          const componentName = this.capitalizeFirstLetter(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''))
          var index = vm.jsData.indexOf(componentName);

          if (0 > index) {
            if (componentName === 'HelpView') {
              Vue.component('Help', componentConfig.default || componentConfig)
              vm.jsData.push(componentName);
            } else if (componentName === 'RegisterView') {
              Vue.component('Register', componentConfig.default || componentConfig)
              vm.jsData.push(componentName);
            } else if (componentName === 'WarningView') {
              Vue.component('Warning', componentConfig.default || componentConfig)
              vm.jsData.push(componentName);
            } else {         
              var found = false;
              for (var i = 0; i < len && !found; i++) { 
                if (vm.pageInfo[0].subMenu[i].jsPath === componentName) {
                  //console.log('MainView: componentName=' + componentName + ' path:' + vm.pageInfo[0].subMenu[i].path)
                  Vue.component(vm.pageInfo[0].subMenu[i].path, componentConfig.default || componentConfig)
                  vm.jsData.push(componentName);
                  found = true
                }
              }
            }
          }
        })
        
        for (let i = 0; i < this.pageInfo.length; i++) {
          if (null != this.pageInfo[i].subMenu) {
            for (var j = 0; j < this.pageInfo[i].subMenu.length; j++) {
              if (sort < this.pageInfo[i].subMenu[j].sort) {
                appId = i;
                pageId = j;
                sort = this.pageInfo[i].subMenu[j].sort;
                cFlag = true;
              }
            }
          }
        }
      }
      if (cFlag) {
        this.toggle(appId, pageId);
      } else {
        this.toggle(-4, -4);
      }
    },
    getDefaultMenu: function (sId, flag) {
	    var vm = this
      if (!flag || (this.pageInfo == null)) {
        var status = (this.user.status == null? 0: this.user.status);
        this.$http
            .get('./WebApi/Common/GetMenuItem/'.concat(this.sysId).concat('/').concat(status))
            .then(function (response) {
              vm.pageInfo = response.data;
              vm.setComponent();              
            })
      }
    }
  },
  created () {
    console.log('======created=====MainView')
    var userAgent = navigator.vendor; 
    this.isIE = navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1; 
    if (this.sysId > 0) {
      this.getDefaultMenu(this.sysId, true);
    }
  },
  watch: {
    sysId (newId, oldId) {
      console.log('======watch sysId====='+newId)
      this.getDefaultMenu(newId, true);
    },
    init(val, oldVal) {
      console.log('======watch init====='+val)
      this.getDefaultMenu(this.sysId, false);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-menu-item, .el-submenu__title{
  font-size: 16px!important;
  height: 32px!important;
  line-height: 32px!important;
}
.el-menu {
  background:transparent;
}

</style>



// WEBPACK FOOTER //
// src/components/MainView.vue